import { Plane, Check } from "lucide-react";

// Airplane-motif order tracking timeline.
export default function OrderTimeline({ statuses, current, timeline = [] }) {
  const idx = statuses.indexOf(current);
  const timeMap = {};
  timeline.forEach((t) => { timeMap[t.status] = t.at; });

  return (
    <div className="relative">
      {/* progress rail */}
      <div className="absolute left-0 right-0 top-5 h-0.5 bg-[#E7DFD3]" />
      <div
        className="absolute left-0 top-5 h-0.5 gold-gradient transition-all duration-700"
        style={{ width: idx <= 0 ? "0%" : `${(idx / (statuses.length - 1)) * 100}%` }}
      />
      {/* flying plane */}
      <Plane
        size={18}
        className="absolute -top-1 text-amber-600 transition-all duration-700"
        style={{ left: `calc(${(Math.max(idx, 0) / (statuses.length - 1)) * 100}% - 9px)` }}
      />
      <div className="relative flex justify-between">
        {statuses.map((s, i) => {
          const done = i <= idx;
          return (
            <div key={s} className="flex w-full flex-col items-center text-center" data-testid={`track-step-${i}`}>
              <div
                className={`z-10 flex h-10 w-10 items-center justify-center rounded-full border-2 transition-colors ${
                  done ? "gold-gradient border-amber-500 text-stone-900" : "border-[#E7DFD3] bg-white text-stone-300"
                }`}
              >
                {done ? <Check size={16} /> : <span className="text-xs font-mono">{i + 1}</span>}
              </div>
              <span className={`mt-2 max-w-[70px] text-[10px] font-medium leading-tight sm:text-xs ${done ? "text-stone-800" : "text-stone-400"}`}>
                {s}
              </span>
              {timeMap[s] && (
                <span className="mt-0.5 text-[9px] text-stone-400">
                  {new Date(timeMap[s]).toLocaleDateString("en-IN", { day: "numeric", month: "short" })}
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
